import Loader from "./Loader";

interface SuspenseFallBackProps {
  img: boolean;
}
export default function SuspenseFallBack(
  props: React.PropsWithChildren<SuspenseFallBackProps>
) {
  return (
    <>
      <Loader />
    </>
  );
}

SuspenseFallBack.defaultProps = {
  img: false,
};
